<template>
  <div class="modal side_menu" @click="hideMenu">
      <div class="menu_cont" @click.stop>
            <div class="logo_s side_menu_logo">
                    <img src="@/assets/images/gif_banana_logo_s.svg" alt="" srcset="">
            </div>
            <ul class="side_menu_links">
                <li>
                    <router-link to="/about">About Gif Banana</router-link>
                </li>
                <li>
                    <router-link to="/terms">Terms &amp; Conditions</router-link>
                </li>
                <li>
                    <router-link to="/privacy">Privacy Policy</router-link>
                </li>
            </ul>
            <div class="side_menu_footer">
                <div class="side_menu_footer_text">
                    <div class="side_menu_rights">
                        All rights reserved Gif Banana &copy; {{year}}
                    </div>
                    <div class="side_menu_signature">
                        Hand crafted by Mahdi Farra
                    </div>
                </div>
            </div>
      </div>
  </div>
</template>

<script>
export default {
    name: 'sideMenu',
    data() {
        return {
            year: new Date().getFullYear(),
        }
    },
    methods: {
        hideMenu() {
            this.$emit('hideMenu');
        },
        toggleBodyScroll() {
            // Stop page from scrolling
            const pageBody = document.body;
            if (pageBody.classList.contains('hideScroll')) {
                pageBody.classList.remove('hideScroll');
            } else {
                pageBody.classList.add('hideScroll');
            }
        },
    },
    mounted() {
        this.toggleBodyScroll();
    },
    destroyed() {
        this.toggleBodyScroll();
    }
}
</script>

<style>

</style>